// Ruta: packages/api-client/src/query-client.ts
// Singleton QueryClient configurado para HeyShaker

import { QueryClient } from '@tanstack/react-query'
import { HTTPError } from 'ky'

function shouldRetry(failureCount: number, error: unknown): boolean {
  // Never retry 5xx errors — circuit-open (503) and backend errors (500) won't
  // recover within the retry window, so retrying just delays the empty-state render.
  if (error instanceof HTTPError && error.response.status >= 500) return false
  return failureCount < 2
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,        // 5 minutos
      gcTime: 30 * 60 * 1000,           // 30 minutos
      retry: shouldRetry,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
})
